import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { RootState } from '../../../store/rootReducer';
import qs from 'qs';
import { Select } from 'antd';
import Button from '../../Button';
import { IGetSemesters, ISemester } from '../../../models/semesters.model';
import Loader from '../../Loader';
import SelectCampus from '../../SelectCampus';
import SelectSemester from '../../SelectSemester';
import useNotification from '../../../hooks/useNotification';
import Checkbox from '../../Checkbox';
import useAxios from '../../../hooks/useAxios';
import { getSemesters } from '../../../api/semesters.api';
import _ from 'lodash';
import i18n from '../../../lib/i18n';

const { Option } = Select;

interface IProps {
  tab: string;
}

const PointSearch: FC<IProps> = ({ tab }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [semesterCode, setSemesterCode] = useState<any>();
  const [semesterOption, setSemesterOption] = useState<any>();
  const { infoNotification } = useNotification();
  const { currentCampus, currentSemesterCode } = useSelector(
    (state: RootState) => state.auth,
  );
  const { isLoading } = useSelector(
    (state: RootState) => state.semester,
  );

  const [keyword, setKeyword] = useState('');
  const [includeClosed, setIncludeClosed] = useState(false);

  const [year, setYear] = useState('');
  const [semesterType, setSemesterType] = useState("");
  const [semesterList, setSemesterList] = useState<ISemester[]>();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find(
    (item) => item.commonCode === 'PR0002',
  )?.detailCode;
  // SY0005 = 연도
  const SY0005 = commonCodes.find(
    (item) => item.commonCode === 'SY0005',
  )?.detailCode;
  const _SY0005 = _.orderBy(SY0005, ['orderSeq'], ['desc']);

  // 검색조건을 쿼리로
  const onSearch = () => {
    if (!currentSemesterCode && !semesterCode) {
      return infoNotification(t('statistics.dttt.message1'));
    }

    const param: any = { page: 1, tab };
    param.campus = currentCampus;
    param.semester = currentSemesterCode || semesterCode;
    
    param.semesterDiv = semesterOption.record.semesterDiv;
    param.learningYearCode = semesterOption.record.learningYearCode;

    if (keyword) param.keyword = keyword;
    if (includeClosed) param.includeClosed = true;

    history.push(`/program/point?${qs.stringify(param)}`);
  };

  const { data: res, error, execute } = useAxios<IGetSemesters>();

  useEffect(() => {
    execute(getSemesters());
   // eslint-disable-next-line react-hooks/exhaustive-deps
   
   if(_SY0005.length > 0) {
    setYear(_SY0005[0].detailCode);
   } else {
    if(query.learningYearCode) {
      //setYear(query.learningYearCode?.toString());
    }
   }
  }, []);

  useEffect(() => {
    fnSetSemesterList(year, semesterType);
  }, [res]);

  const fnSetSemesterList = (tYear : string, tSemesterType : string) => {
    setSemesterCode(undefined);
    if(res?.data) {
      const tempList = res?.data?.filter((item)=>{
        return item.learningYearCode === tYear && (tSemesterType ? item.semesterType === tSemesterType : true);
      });
      
      setSemesterList(tempList);
    }
  }

  return (
    <>
      {isLoading ? <Loader /> : null}
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>
              <label>{t('common.menu.campus')}</label>
              <div>
                <SelectCampus />
              </div>
            </li>
            <li>
              <label>
                {t('program.semester.column9')}
              </label>
              <Select
                className="w-120p"
                value={year}
                onChange={value => {
                  setYear(value);
                  fnSetSemesterList(value, semesterType);
                }}
              >
                {
                  _SY0005!.map(({korName: label, detailCode: value}) => {
                    return (
                      <Select.Option key={value} value={value}>
                        {label}
                      </Select.Option>
                    )
                  })
                }
              </Select>
            </li>
            <li>
            <label>{t('common.semester.type')}</label>
              <Select
                value={semesterType}
                onChange={(value)=>{
                  if(setSemesterType) {
                    setSemesterType(value);
                  }
                  fnSetSemesterList(year, value);
                }}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                {
                  PR0002?.map((item) => {
                    return (
                      <Select.Option
                          key={item.detailCode}
                          value={item.detailCode}
                      >
                          {i18n.language === 'ko' ? item.korName : item.engName}
                      </Select.Option>
                    );
                  })
                }
              </Select>
            </li>
            <li>
              <label>{t('class.class.placeholder4')}</label>
              <div>
                <Select
                  placeholder={t('class.class.placeholder4')}
                  value={semesterCode}
                  onChange={(value, options) => {
                    setSemesterCode(value);
                    if (setSemesterOption) {
                      setSemesterOption(options);
                    }
                  }}
                >
                  {semesterList?.map((item) => (
                    <Select.Option
                      key={item.semesterCode}
                      record={item}
                      value={item.semesterCode}
                    >
                      {item.semesterName}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </li>
            <li>
              <label>{t('class.class.placeholder3')}</label>
              <div>
                <input
                  type="text"
                  className="form-control "
                  placeholder={t('class.class.placeholder3')}
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyPress={(e) => {}}
                />
              </div>
              <Checkbox
                checked={includeClosed}
                onChange={() => setIncludeClosed(!includeClosed)}
                text={t('class.class.option1')}
              />
              <div className="comm-btn__area">
                <Button
                  className="btn-basic small black"
                  onClick={() => onSearch()}
                  text={t('common.button.search')}
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default PointSearch;
